import { DetailValue } from 'components/DetailsView/DetailValue';
import { SectionColumn, SectionContainer, ColumnsSectionContainer } from 'components/DetailsView/Section';
import { DetailLink } from 'components/DetailsView';

import { WarehouseReturnFragmentFragment } from 'data/__generated__';

export const GeneralInfoSection = ({ warehouseReturn }: { warehouseReturn: WarehouseReturnFragmentFragment }) => {
    return (
        <SectionContainer title="Informations générales" isInitiallyOpen>
            <ColumnsSectionContainer numberOfColumns={2}>
                <SectionColumn>
                    <DetailValue label="ID" value={warehouseReturn._id} />
                    <DetailValue label="Date" value={warehouseReturn.date} />
                </SectionColumn>
                <SectionColumn>
                    <DetailLink
                        label="Site d'origine"
                        path="site"
                        name={warehouseReturn.originColumnId}
                        value={warehouseReturn.originColumnId}
                    />
                    <DetailLink
                        label="Entrepôt de destination"
                        path="site"
                        name={warehouseReturn.warehouseColumnId}
                        value={warehouseReturn.warehouseColumnId}
                    />
                </SectionColumn>
            </ColumnsSectionContainer>
        </SectionContainer>
    );
};
